type GetNoAvailabilitiesMessageParams = {
  date: string;
  partySize: number;
  phoneNumber: string;
  emailAddress: string;
};

// TODO: We'll have more conditions in the future for the following cases:
// 1. If we choose more than the maximum allowed, we ask the diner to call or email
function getNoAvailabilitiesMessage({
  date,
  partySize,
  phoneNumber,
  emailAddress
}: GetNoAvailabilitiesMessageParams): string {
  const numberOfGuests = `${partySize} guest${partySize == 1 ? '' : 's'}`;

  let contactClause = '';
  if (phoneNumber) {
    contactClause = `Contact us directly to see if we can accommodate your party at ${phoneNumber}.`;
  } else if (emailAddress) {
    contactClause = `Contact us directly to see if we can accommodate your party at ${emailAddress}.`;
  } else {
    contactClause =
      'Contact us directly to see if we can accommodate your party.';
  }

  return `We don't have any online reservations available for ${numberOfGuests} on ${date}. ${contactClause}`;
}

export { getNoAvailabilitiesMessage };
